import { render, staticRenderFns } from "./notification.component.vue?vue&type=template&id=8572cdc2&scoped=true"
import script from "./notification.component.vue?vue&type=script&lang=js"
export * from "./notification.component.vue?vue&type=script&lang=js"
import style0 from "./notification.component.vue?vue&type=style&index=0&id=8572cdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8572cdc2",
  null
  
)

export default component.exports